import { createRoot } from 'react-dom/client'
import './styles.css'
import { App, Customizer } from './App'
import { Logo } from '@pmndrs/branding'
import { useSnapshot } from 'valtio'
import { state } from './store'

function Overlay() {
  const snap = useSnapshot(state);

  return (
    <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}>
      <div className="customizer">
        <div className="color-options">
          {snap.colors.map((color, index) => (
            <div key={index} className="circle" style={{ background: color }} onClick={() => (state.color = color)}></div>
          ))}
        </div>
      </div>
    </div>
  )
}

createRoot(document.getElementById('root')).render(
  <>
    <App />
    <Overlay />
  </>
)
